<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">게시판 관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
						<li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">공지사항 관리</p>
					<ul class="depth">
						<li><router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link></li>
						<li><router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">공지사항 등록</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>공지사항 등록 테이블</caption>
                            <colgroup>
                                <col style="width: 15%; min-width: 80px;">
                                <col style="width: auto;">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">제목<span class="redDot">*</span></th>
                                    <td>
                                        <input type="text" title="제목 입력" v-model="title">
										<div class="error" v-if="!$v.title.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">내용<span class="redDot">*</span></th>
                                    <td>
                                        <ckeditor :editor="editor" v-model="cts" :config="editorConfig" @ready="onReady"></ckeditor>
										<div class="error" v-if="!$v.cts.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">첨부파일</th>
                                    <td>
                                        <div class="fileArea">
                                            <p class="upload-name">{{ firstName }}</p>
                                            <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile"/>
                                            <label for="file" class="btn gray">파일첨부</label>
                                        </div>
                                        <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--table-->
                </article>
                <article class="btnArea">
                    <button class="btn gray" @click="$router.push('noticemanagement')">취소</button>
                    <button class="btn blue" @click="insertBtn">저장</button>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";
import { required }        from 'vuelidate/lib/validators'
import ClassicEditor       from '@ckeditor/ckeditor5-build-classic';
import CKEditor            from '@ckeditor/ckeditor5-vue2';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
const uploadAdapter = require("../../../assets/js/UploadAdapter");

export default {
	data(){
		return{
			cts                : '',
			title              : '',
			eFiles             : [''],
			submitStatus       : '',
			firstName		   : '',
			editor             : ClassicEditor,
			editorConfig       : {
				language         : 'ko',
				enterMode        : 2,
				shiftEnterMode   : 3,
				extraPlugins     : [ uploadAdapter.MyCustomUploadAdapterPlugin ],
				mediaEmbed       : {
					previewsInData : true,
				}
			},
		}
	},

	validations : {
		title : {
			required
		},
		cts   : {
			required
		}
	},

	compoents : {
		ckeditor : CKEditor.compoents,
	},

	methods: {
		onReady(editor){
			editor.ui.getEditableElement().parentElement.insertBefore(
				editor.ui.view.toolbar.element,
				editor.ui.getEditableElement()
			);
		},

		async insertBtn() {
			if (this.$v.$invalid) {
				return;
			}
			this.initEFiles();
			

			let apiParams = new FormData();
			apiParams.append("title", this.title);
			apiParams.append("cts"  , this.cts);
			apiParams.append("bbsCd", this.bbsCd);
			if(this.eFiles !== '') {
				this.eFiles.forEach(e => {
					apiParams.append("files", e);
				});
			};
			await axios('post', "/api/admin/board/notice/insertAction.json", apiParams);
			await this.$router.push('noticemanagement');

		},

		changeFile(e) {
			const file = e.target.files[0];
			
			if (file.size > 2000000) {
				alert('최대 20mb까지 업로드할 수 있습니다.');
				this.resetFile();
				return;
			}

			if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
				this.firstName = file.name;
        this.eFiles.push(file);
			}
		},

		resetFile(){
			this.$refs.files.value = '';
			this.eFiles = [];
		},

		initEFiles(){
			if(this.eFiles.length == 0){
				this.eFiles = '';
			}
		},
	},
}
</script>

